import { Card, Stack, Row, Col, Button} from "react-bootstrap";
import { useState } from "react";
import Motivo from "../funcionarios/Motivo.jsx";
import EstadoModulo from "../funcionarios/EstadoModulo.jsx";
import {
  actualizarMeson,
  actualizarFuncionario,
} from "../../services/apis_jefatura.js";

function AdminModuloTarjeta({
  id,
  nombre,
  numero,
  estado,
  funcionario,
  motivos,
  onEdit,
  onModulosChanged,
  onConfirmDesactivar,
}) {
  const [switchChecked, setSwitchChecked] = useState(
    estado === "activo" || estado === "inactivo"
  );

  const handleEditClick = () => {
    onEdit?.({ id, nombre, numero, estado, motivos });
  };

  // Función para actualizar el estado del módulo via API
  const actualizarEstadoModulo = async (activar) => {
    const nuevoEstado = activar ? "inactivo" : "no-disponible";
    try {
      if (!activar && funcionario && funcionario.id) {
        await actualizarFuncionario(funcionario.id, { meson: null });
        console.log(`Funcionario ${funcionario.nombre} desasignado del módulo`);
      }

      await actualizarMeson(id, { estado: nuevoEstado });
      setSwitchChecked(activar);
      onModulosChanged?.();
    } catch (err) {
      console.error("Error actualizando módulo:", err);
      alert("No se pudo actualizar el estado del módulo.");
    }
  };

  const handleSwitchChange = (e) => {
    const checked = e.target.checked;
    if (!checked) {
      onConfirmDesactivar?.({
        id,
        nombre,
        onConfirm: () => actualizarEstadoModulo(false),
      });
    } else {
      actualizarEstadoModulo(true);
    }
  };

  const styles = {
    card: {
      backgroundColor:
        estado !== "no-disponible"
          ? "var(--color-background)"
          : "var(--color-gray)",
    },
    switch: {
      transform: "scale(1.3, 1.6)",
      backgroundColor: "var(--color-accent)",
      borderColor: "var(--color-accent)",
    },
  };

  return (
    <Card className="h-100" style={styles.card}>
      {/* === EL CAMBIO CLAVE === */}
      <Card.Body className="p-3 d-flex flex-column h-100">
        {/* Contenido superior empujable */}
        <div className="flex-grow-1">
          <Row className="mb-4 d-flex align-items-center g-2">
            <Col xs="auto">
              <p className="mb-1 h5">{nombre}</p>
            </Col>

            <Col xs="auto" className="ms-auto">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id={`switch-${numero}`}
                  checked={switchChecked}
                  onChange={handleSwitchChange}
                  style={styles.switch}
                />
              </div>
            </Col>
          </Row>

          <div className="mt-2">
            {motivos.length !== 0 ? (
              <Stack direction="horizontal" className="flex-wrap" gap={1}>
                {motivos
                  .filter((m) => m.activo !== false)
                  .map((m) => (
                    <Motivo key={m.id} motivo={m.nombre} />
                  ))}
              </Stack>
            ) : (
              <Motivo motivo="Sin motivo asignado" />
            )}
          </div>

          <div className="mt-2">
            <EstadoModulo estado={estado} />
          </div>
        </div>

        {/* === Footer fijo al fondo === */}
        <Row className="mt-auto pt-2 align-items-center d-flex">
          <Col className="d-flex align-items-center">
            {funcionario && (
              <small className="text-muted">
                Atendido por: <p className="fw-semibold">{funcionario.nombre}</p>
              </small>
            )}
          </Col>

          <Col xs="auto" className="ms-auto mt-auto">
            <Button onClick={handleEditClick} className="edit-btn p-0">
              <i className="bi bi-pencil-square"></i>
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default AdminModuloTarjeta;